import styled from "styled-components/macro";
import { SecondaryButton, PrimaryButton } from "@loanbossinc/component-library";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSearchHeader = styled.div`
  border-bottom: 1px solid #dadce0;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  width: 100%;
  padding: 1.5em 0;
  z-index: 1;
`;

export const PaddedWrapper = styled.div`
  padding: 0 1em;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 1em;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    width: 132px !important;
    height: 36px !important;
    font-size: 14px;
    border: 1px solid #005aa9;
    color: #005aa9;
  }
`;

export const FieldWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const FieldLeftContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const FieldIconWrapper = styled.div`
  && {
    padding: 0 1em;
  }
`;

export const FieldNameTypeWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const FieldTypeWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Row = styled.div`
  && {
    align-items: center;
    background: #ffffff;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    box-sizing: border-box;
    display: flex;
    min-height: 88px;
    justify-content: ${props => props.justifyContent || "space-between"};
    width: 100%;
  }
`;

export const FieldRightContentWrapper = styled.div`
  && {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    padding: 0 1em;
    text-align: right;
  }
`;

export const StyledSelectButton = styled(PrimaryButton)`
  && {
    background-color: ${ props => (props.isSelected ? "rgba(0, 90, 169, 0.54)" : "#005aa9") } !important;
    width: 132px !important;
    height: 36px !important;
  }
`;
